"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var react_1 = require("react");
var Divider_1 = require("../../atoms/Divider/Divider");
var FloatingMenu_style_1 = __importDefault(require("./FloatingMenu.style"));
/**
 * FloatingMenu molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-floatingmenu--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/FloatingMenu Source}
 */
var FloatingMenu = function (_a) {
    var className = _a.className, children = _a.children, position = _a.position, small = _a.small;
    var classes = (0, FloatingMenu_style_1.default)();
    var dividerMargin = small ? 12 : 24;
    var numberOfChildren = react_1.Children.count(children);
    var isLastItem = function (index) { return numberOfChildren - 1 === index; };
    var _b = (0, lodash_1.defaultsDeep)(position), top = _b.top, right = _b.right, bottom = _b.bottom, left = _b.left;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.menu, small && classes.menuSmall, className), style: { top: top, right: right, bottom: bottom, left: left } }, { children: react_1.Children.map(children, function (child, index) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [child, !isLastItem(index) && ((0, jsx_runtime_1.jsx)(Divider_1.Divider, { margin: { left: dividerMargin, right: dividerMargin }, vertical: true }, "category-divider-".concat(index)))] }));
        }) })));
};
exports.FloatingMenu = FloatingMenu;
